import { render, staticRenderFns } from "./DeliveryRateWidget.vue?vue&type=template&id=7db9c0cd&"
import script from "./DeliveryRateWidget.vue?vue&type=script&lang=js&"
export * from "./DeliveryRateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports